export const CREATE = "CREATE";
export const READPROD = "FETCH_PRODUCTS";
export const READUSER = "FETCH_USERS";
export const UPDATE = "UPDATE";
export const DELETE = "DELETE";
export const ERROR = "ERROR";
export const ERRORUSER = "ERRORUSER";
export const LOADING = "LOADING";
export const LOADINGUSER = "LOADINGUSER";
export const READCAT = "FETCH_CATEGORIES";
export const STATUS = "STATUS";
export const STATUSUSER = "STATUSUSER";
export const FETCHTB = "FETCH_TOP_BIDDER";
export const FETCHCB = "FETCH_CURRENT_BIDDER";
export const FETCHUSER = "FETCH_USER";

export const CREATEUSER = "CREATEUSER";
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";

export const READ_PROD_DET_REQUEST = "FETCH_PRODUCT_DETAILS_REQUEST";
export const READ_PROD_DET_SUCCESS = "FETCH_PRODUCT_DETAILS_SUCCESS";
export const READ_PROD_DET_FAIL = "FETCH_PRODUCT_DETAILS_FAIL";

export const SET_ACTIVE_CATEGORY = "SET_ACTIVE_CATEGORY";

export const SEARCH_BIDDABLE_PRODUCTS_REQUEST =
	"SEARCH_BIDDABLE_PRODUCTS_REQUEST";
export const SEARCH_BIDDABLE_PRODUCTS_SUCCESS =
	"SEARCH_BIDDABLE_PRODUCTS_SUCCESS";
export const SEARCH_BIDDABLE_PRODUCTS_FAIL = "SEARCH_BIDDABLE_PRODUCTS_FAIL";
